import {
  SET_CATEGORY_SALES_LOADING,
  GET_CATEGORY_SALES_SUCCESS,
  GET_CATEGORY_SALES_ERROR,
} from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const getCategorySalesReports = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_CATEGORY_SALES_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const queryParams = {
      companyId,
      branchId,
      ...params,
    };

    const res = await Axios.get(
      '/api/dashboard/purchase-items/find-category-wise-sales',
      {
        params: queryParams,
      }
    );

    dispatch({
      type: GET_CATEGORY_SALES_SUCCESS,
      payload: {
        data: res.data.data,
        pagination: res.data.pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: GET_CATEGORY_SALES_ERROR,
      payload: err.message || 'Failed to fetch category sales',
    });
  } finally {
    dispatch({ type: SET_CATEGORY_SALES_LOADING, payload: false });
  }
};

export const exportCategorySalesReports = (params) => async () => {
  try {
    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const getTimestampString = () => {
      const pad = (num) => String(num).padStart(2, '0');
      const d = new Date();
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
    };

    const requestBody = {
      columns: [
        {
          key: 'categoryName',
          header: 'Category',
        },
        {
          key: 'sum_total_amount',
          header: 'Sales',
        },
        {
          key: 'sum_cost',
          header: 'Cost',
        },
        {
          key: 'sum_profit',
          header: 'Profit',
        },
      ],
      filename: `category_sales_export_${getTimestampString()}.xlsx`,
      sheetName: 'Category Sales',
      companyId,
      branchId,
      ...params,
    };

    const response = await Axios.post(
      '/api/dashboard/purchase-items/export-category-wise-sales-excel',
      requestBody,
      {
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }
    );

    const contentDisposition = response?.headers?.['content-disposition'];
    let downloadFileName =
      requestBody.filename || `category_sales_export.xlsx`;
    if (contentDisposition && contentDisposition.includes('filename=')) {
      const match = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
      );
      downloadFileName = decodeURIComponent(
        match?.[1] || match?.[2] || downloadFileName
      );
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Export category sales failed', error);
  }
};


